'use client';
import { rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getRectangularVariantSizes = function(param) {
    var height = param.height, width = param.width, radius = param.radius;
    return _extends({}, !height && {
        alignSelf: "stretch"
    }, {
        height: height ? rem(height) : "auto",
        width: width ? rem(width) : "100%"
    }, radius && {
        borderRadius: rem(radius)
    });
};

export { getRectangularVariantSizes };
